var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"tn-tag-class tn-tag",class:[
    _vm.tagClass,
    _vm.backgroundColorClass,
    _vm.fontColorClass
  ],style:([_vm.tagStyle]),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleClick).apply(void 0, arguments)
}}},[_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }